module.exports = __webpack_public_path__ + "static/media/ecommerce.28a31392.png";